import { SignIn } from "@clerk/tanstack-react-start";
import { createFileRoute } from "@tanstack/react-router";
import { loginHead, validateLoginSearch } from "~/lib/login-search.ts";

/**
 * ClawInstall admin login page
 *
 * The brand's admin door — reachable at `clawinstall.ai/admin/login`. This is
 * where the "Admin Portal" copy belongs: it encodes the *intent* to do admin
 * work, so after sign-in it lands the user on `/clawinstall/admin`. The file
 * lives under `admin_/` (a TanStack non-nested route) so it keeps the
 * `/admin/login` URL while opting OUT of the role-gated `/clawinstall/admin`
 * layout — otherwise an unauthenticated visitor would be bounced by the admin
 * guard before ever seeing the login form. Authorization for the admin console
 * itself is enforced by that guard, not by this redirect.
 *
 * @since 1.0.0
 */
export const Route = createFileRoute("/clawinstall/admin_/login/")({
  validateSearch: validateLoginSearch,
  head: ({ match }) => loginHead(match.context.identity?.displayName ?? "ClawInstall"),
  component: ClawInstallAdminLogin,
});

export function ClawInstallAdminLogin() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-surface px-6">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <h1 className="font-headline-md text-headline-md tracking-tight text-on-surface">
            ClawInstall
          </h1>
          <p className="mt-2 font-body-md text-body-md text-on-surface-variant">
            Admin Portal
          </p>
        </div>
        <SignIn
          routing="path"
          path="/admin/login"
          fallbackRedirectUrl="/clawinstall/admin"
        />
      </div>
    </div>
  );
}
